import { SORT_ORDER } from './general';

export type SortOption = {
	label: string;
	value: SORT_ORDER;
};

export interface ShopFiltersState {
	selectedCategories: string[];
	sortOrder: SORT_ORDER;
	currentPage: number;
}

export enum SHOP_CHIP_STATUS {
	HOT = 'Hot',
	NEW = 'New'
}
